import sliceCreator from '../../index.jsx';
import {VERIFY_FORGOT_PASSWORD} from '../../../constants/index.jsx';
const _verifyForgotPasswordAction = sliceCreator('VERIFY_FORGOT_PASSWORD', VERIFY_FORGOT_PASSWORD, 'post');

const { asyncAction: verifyForgotPasswordAction, reducer, clearData: clearVerifyForgotPasswordAction } = _verifyForgotPasswordAction;

export default reducer;

export {
    verifyForgotPasswordAction,
    clearVerifyForgotPasswordAction
}